<template>
    <doc-layout>
      <nuxt />
    </doc-layout>
</template>

<script>
import DocLayout from "../components/DocLayout.vue"
export default {
    components: {
       DocLayout
    }
};
</script>